export default __webpack_public_path__ + "static/city-border-e11d0d0962b2b09195eda187af7e1036.svg";